 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		38: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		38: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"45a421bdd2d31c58a0e7a9870e5ce434588ef09f","2":"0510f3023e1b86d5844ba16b1a4a148020ffae93","3":"e8fc4988ec544be66da8f61ecb54d5f74c5069d3","4":"172941ee06c84063da2ec87ddf885915ce2a6a41","5":"51ceccef1d5c80ec7916f586cf2229b66c922739","6":"abb492f5","7":"1d8452400776bc82257ace3e94ab538106212850","8":"1dafc9193eac84937b70c739b7724701010684cb","9":"1f48adde20bae330dee8dc4471f3edcde927e206","10":"21ebcdfe1af344ebdf072df64ccb94bbf3d8bf94","11":"24c1e3d5785032e62bd40c0fa3acbb656d53db90","12":"4dbfb264","13":"4fba96a1","14":"50302ffa095870174e486111d5ef0cca4c5b5002","15":"6bd23da736923ff49fa8dadcfc2edbe652a36c76","16":"796597c2fa54f759363b9f3a24ad28b444a7898a","17":"810f3ef6","18":"86674dbb00fe76a372183b9a63494dbec8213616","19":"8f0aab2492a759d2e3d98093044e68ef4b64c918","20":"bcb64ca38b57a579f744da95ef7f0f265161b7ec","21":"cddf0c66aad7369681a025f9e1f6ed7e72831483","22":"ce62a75bd614ec97973ffbb3a916b544ee72fac4","23":"d25d635e151f91e0b9ad00f79851299cb29b80dd","24":"01147527","25":"1b2f365ebd18a5de4218fce5a348bee6ed0b3a06","26":"4cc4b20074d79a26a547c9b82ea985978af54451","27":"7569a2911ac388112c86c41a1f3c00d5a138b2b6","28":"88300e08","29":"88c72c539a8c211748f1aa32411a09dc7d3ca0a8","30":"8beaf7b5","31":"abbd24c9ba6b21687455a5198839fff314218f43","32":"b3ea46548516631a61fe2adedfd63b9d6cf39642","33":"c46307d4a97b268d63bbd06779bda66cc9742e14","34":"e8d3a20a8f683447ba05c13098381e9693f26a71","35":"f150a4ef9ec5eb876492d1e43f4d43204cf9e54e","36":"547e7c7621e670923db6914db5dca278359bf8ef","37":"d35a55eb","40":"component---src-pages-404-js","41":"component---src-pages-about-js","42":"component---src-pages-berufsmantel-js","43":"component---src-pages-cart-js","44":"component---src-pages-classico-hose-js","45":"component---src-pages-classico-jacke-js","46":"component---src-pages-classico-shorts-js","47":"component---src-pages-damenkasack-js","48":"component---src-pages-dynamix-js","49":"component---src-pages-fleecejacke-primo-js","50":"component---src-pages-gilet-primo-knopfen-js","51":"component---src-pages-gilet-primo-rv-js","52":"component---src-pages-index-js","53":"component---src-pages-jackets-js","54":"component---src-pages-latzhose-primo-js","55":"component---src-pages-overall-primo-js","56":"component---src-pages-pants-js","57":"component---src-pages-parka-primo-aussenjacke-js","58":"component---src-pages-parka-primo-innenjacke-js","59":"component---src-pages-polar-js","60":"component---src-pages-shared-js","61":"component---src-pages-softshelljacke-js","62":"component---src-pages-softshelljacke-plus-js","63":"component---src-pages-trend-gilet-js","64":"component---src-pages-trend-js","65":"component---src-pages-ultimate-trousers-js","68":"styles"}[chunkId]||chunkId) + "-" + {"0":"3261a8818d94474bfc73","1":"6e234cd0d9760917d6de","2":"fdfb850c1d4d0de88f7a","3":"f79777ffc1cfa36ed047","4":"4a07de880d951b8e24af","5":"267e1e825eb8c81a5dcf","6":"afe55c2e84305f5e5c13","7":"d9a583d4bb33d71ef35a","8":"5fb8d942ec9be6b32f79","9":"d183123a341034c6e04f","10":"e9edfba376e82cf12fb6","11":"778a3a80cd07ee53dd38","12":"0700066cbaa788fdb6e1","13":"ad2009b137ca3877fd38","14":"eb55e2bee28630ed8f1e","15":"2065f43aca849f6fc07b","16":"715a46692689c149574f","17":"55b7523af27e16f039c6","18":"b521755951f67c249353","19":"2442f63b8be63639a5a4","20":"1a2d64c3fc9f799bcaf1","21":"19858c8ab42df8baa82f","22":"4609e0286c652441031b","23":"c0d1b25897eda413bfb2","24":"834e65128970b92b3f53","25":"d3231ddbb172484a77f9","26":"a547e640a9cb203ed52f","27":"dda29b7668ffb94a2e35","28":"9f396005679172eba72b","29":"83b00536202838c7d841","30":"5b283d60ba94a58be3bb","31":"f68605b4b661111c0977","32":"038a8c092d6a5339512d","33":"2f72ebeff32f652a4465","34":"78e25ca46236b5f1c19f","35":"26e331210f2c7c3761de","36":"ad2a6ba10376cce255d7","37":"5c22198c90c276d79a65","40":"92a7312fa580cd84d2ee","41":"58b0d5646e728014198c","42":"fb991fe04201d55aa73b","43":"c42bab855d50924e2175","44":"5a7b62a75361610ce651","45":"1e80a042518c3e365e8d","46":"04d41075af980c29771f","47":"1d781011e7a8ef6cfc95","48":"877a329e0ffd3c800a16","49":"4736c2290def45aa7b2b","50":"04291ed62aae7f35d67e","51":"8aeb11b0430ed61769db","52":"8a398d23d8d6f58aa259","53":"a2188b19a0695f542296","54":"ecba28715e0e0f964769","55":"4a49362a6b4b93a0c95b","56":"7f279840ee4305d24e64","57":"cc98b93496905a0e4af8","58":"2dcc76d5d7867c0894ca","59":"7f3f6aaf83dcde74bdb7","60":"3582a06259623495e63c","61":"11996cd7b5f312f577bb","62":"b199fbdc456b8347f9aa","63":"407b6d0866916b1095d5","64":"47ff49279bb52b272e6d","65":"bcc80251d20791e2d2f1","68":"6c6663a8b6344a79b97c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"68":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"45a421bdd2d31c58a0e7a9870e5ce434588ef09f","2":"0510f3023e1b86d5844ba16b1a4a148020ffae93","3":"e8fc4988ec544be66da8f61ecb54d5f74c5069d3","4":"172941ee06c84063da2ec87ddf885915ce2a6a41","5":"51ceccef1d5c80ec7916f586cf2229b66c922739","6":"abb492f5","7":"1d8452400776bc82257ace3e94ab538106212850","8":"1dafc9193eac84937b70c739b7724701010684cb","9":"1f48adde20bae330dee8dc4471f3edcde927e206","10":"21ebcdfe1af344ebdf072df64ccb94bbf3d8bf94","11":"24c1e3d5785032e62bd40c0fa3acbb656d53db90","12":"4dbfb264","13":"4fba96a1","14":"50302ffa095870174e486111d5ef0cca4c5b5002","15":"6bd23da736923ff49fa8dadcfc2edbe652a36c76","16":"796597c2fa54f759363b9f3a24ad28b444a7898a","17":"810f3ef6","18":"86674dbb00fe76a372183b9a63494dbec8213616","19":"8f0aab2492a759d2e3d98093044e68ef4b64c918","20":"bcb64ca38b57a579f744da95ef7f0f265161b7ec","21":"cddf0c66aad7369681a025f9e1f6ed7e72831483","22":"ce62a75bd614ec97973ffbb3a916b544ee72fac4","23":"d25d635e151f91e0b9ad00f79851299cb29b80dd","24":"01147527","25":"1b2f365ebd18a5de4218fce5a348bee6ed0b3a06","26":"4cc4b20074d79a26a547c9b82ea985978af54451","27":"7569a2911ac388112c86c41a1f3c00d5a138b2b6","28":"88300e08","29":"88c72c539a8c211748f1aa32411a09dc7d3ca0a8","30":"8beaf7b5","31":"abbd24c9ba6b21687455a5198839fff314218f43","32":"b3ea46548516631a61fe2adedfd63b9d6cf39642","33":"c46307d4a97b268d63bbd06779bda66cc9742e14","34":"e8d3a20a8f683447ba05c13098381e9693f26a71","35":"f150a4ef9ec5eb876492d1e43f4d43204cf9e54e","36":"547e7c7621e670923db6914db5dca278359bf8ef","37":"d35a55eb","40":"component---src-pages-404-js","41":"component---src-pages-about-js","42":"component---src-pages-berufsmantel-js","43":"component---src-pages-cart-js","44":"component---src-pages-classico-hose-js","45":"component---src-pages-classico-jacke-js","46":"component---src-pages-classico-shorts-js","47":"component---src-pages-damenkasack-js","48":"component---src-pages-dynamix-js","49":"component---src-pages-fleecejacke-primo-js","50":"component---src-pages-gilet-primo-knopfen-js","51":"component---src-pages-gilet-primo-rv-js","52":"component---src-pages-index-js","53":"component---src-pages-jackets-js","54":"component---src-pages-latzhose-primo-js","55":"component---src-pages-overall-primo-js","56":"component---src-pages-pants-js","57":"component---src-pages-parka-primo-aussenjacke-js","58":"component---src-pages-parka-primo-innenjacke-js","59":"component---src-pages-polar-js","60":"component---src-pages-shared-js","61":"component---src-pages-softshelljacke-js","62":"component---src-pages-softshelljacke-plus-js","63":"component---src-pages-trend-gilet-js","64":"component---src-pages-trend-js","65":"component---src-pages-ultimate-trousers-js","68":"styles"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","68":"e2c4522031bfe65f1e76"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
